var _circle, _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenefit8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "url(#paint0_linear_11688_28204)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3866 17.9453C15.3866 17.6546 15.15 17.418 14.8593 17.418H14.2616V18.4727H14.8593C15.15 18.4727 15.3866 18.2361 15.3866 17.9453Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23.7436H28V14.2563H10V23.7436ZM24.2414 16.3633H24.793V17.4179H24.2414C23.3689 17.4179 22.6594 18.1278 22.6594 19C22.6594 19.8722 23.3689 20.582 24.2414 20.582H24.793V21.6367H24.2414C22.7874 21.6367 21.6047 20.454 21.6047 19C21.6047 17.5459 22.7874 16.3633 24.2414 16.3633ZM17.4914 16.3633H20.5391V17.4179H18.5461V18.4726H20.5391V19.5273H18.5461V20.582H20.5391V21.6367H17.4914V16.3633ZM13.207 16.3633H14.8593C15.7315 16.3633 16.4413 17.0731 16.4413 17.9453C16.4413 18.4579 16.1963 18.9142 15.8173 19.2035C16.1864 19.6054 16.4121 20.1412 16.4121 20.7286V21.6367H15.3575V20.7286C15.3575 20.1018 14.8748 19.5857 14.2616 19.5319V21.6367H13.207V16.3633Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0547 11.0547H12.9057V10H10V12.9057H11.0547V11.0547Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0942 10V11.0547H26.9453V12.9057H28V10H25.0942Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0547 25.0942H10V28H12.9057V26.9453H11.0547V25.0942Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9453 26.9453H25.0942V28H28V25.0942H26.9453V26.9453Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11688_28204",
    x1: 38,
    y1: 38,
    x2: -2.04925,
    y2: 35.7012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#571EC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA08A8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefit8);
export default __webpack_public_path__ + "static/media/benefit-8.6b5857eca8a008b0bfb95278ce10cd02.svg";
export { ForwardRef as ReactComponent };